import React, {PureComponent, Fragment} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Icon, ThemeContext, HelpPanel} from '../../';

export default class Wrapper extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.array,
    ]).isRequired,
    user: PropTypes.shape({
      help: PropTypes.boolean,
    }).isRequired,
    helpToggle: PropTypes.func,
  };

  static defaultProps = {
    user: {
      help: false,
    },
    helpToggle: null,
  };

  state = {
    isHelpPanelOpened: false,
    isTreasurePanelOpened: false,
    isLeaderboardPanelOpened: false,
  };

  onHelpPanelToggle = () => {
    const {isHelpPanelOpened} = this.state;
    this.setState({isHelpPanelOpened: !isHelpPanelOpened});
  };

  onHelpPanelClose = () => {
    this.setState({isHelpPanelOpened: false});
    this.props.helpToggle({status: false});
  };

  render() {
    const {isHelpPanelOpened} = this.state;
    const {children, user: {help}} = this.props;
    const classes = classnames(
      'help-toggle',
      {
        'help-toggle_opened': isHelpPanelOpened,
      }
    );
    const wrapClasses = classnames(
      'help-toggle__wrapper row row_space-between row_gap_m row_column-m',
      {
        'help-toggle__wrapper_dimmed': isHelpPanelOpened,
      }
    );
    return (
      <ThemeContext.Consumer>
        {template => (
          <Fragment>
            <div
              role="button"
              tabIndex={0}
              className={classes}
              style={{backgroundColor: template.primaryColor}}
              onClick={this.onHelpPanelToggle}
            >
              <Icon iconSize="22" glyph="question"/>
              <br/>
              <span>HELP</span>
            </div>
            <HelpPanel isOpened={isHelpPanelOpened || help} onClose={this.onHelpPanelClose}/>
            <div className={wrapClasses}>
              {children}
            </div>
          </Fragment>
        )}
      </ThemeContext.Consumer>
    );
  }
}
